export enum UserPermissionType {
  ParentUser = 1,
  RakazUser = 2,
}



// WEBPACK FOOTER //
// ./src/app/_models/user/user-permission-type.ts